/**
 * Supabase Client
 *
 * Centralized Supabase client for database, auth, real-time, and storage.
 * All queries use parameterized statements (Supabase client) - SQL injection is prevented.
 *
 * Session security:
 * - Tokens stored in localStorage (persist across browser close)
 * - autoRefreshToken: refreshes before expiry
 * - detectSessionInUrl: handles OAuth/magic link callbacks
 */

import { createClient } from '@supabase/supabase-js';

// Fallback if env vars are cached/placeholder (CRA loads env at startup only)
const urlFromEnv = process.env.REACT_APP_SUPABASE_URL || '';
const keyFromEnv = process.env.REACT_APP_SUPABASE_ANON_KEY || '';
const isPlaceholder = urlFromEnv.includes('your-project-id') || keyFromEnv.includes('your-anon-key');

const supabaseUrl = isPlaceholder
  ? 'https://bvlhpsghcddxlltecezw.supabase.co'
  : urlFromEnv;
const supabaseAnonKey = isPlaceholder
  ? 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImJ2bGhwc2doY2RkeGxsdGVjZXp3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NzA3MjQzMTEsImV4cCI6MjA4NjMwMDMxMX0.qjJKueTS9BdDq-fNb-6mdo2xTrKJBoG4u89COMwj710'
  : keyFromEnv;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error(
    'Missing Supabase environment variables. ' +
    'Please set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY in frontend/.env'
  );
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey, {
  auth: {
    autoRefreshToken: true,
    persistSession: true,
    detectSessionInUrl: true,
    storageKey: 'smartwaste-auth',
  },
});

export default supabase;
